import React, { forwardRef } from 'react';

import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';

export const wideBreakpoints = {
    sDesktop: '1567px',
    laptop: '1279px',
    tablet: '999px',
    mobile: '767px',
    sMobile: '359px',
};

export const mobileFirstBreakpoints = {
    sDesktop: '1568px',
    laptop: '1280px',
    tablet: '1000px',
    mobile: '768px',
    sMobile: '360px',
};

export interface IProps {
    children: React.ReactNode,
    fullwidth?: boolean,
    [key: string]: any,
}

const WideContainer = forwardRef(({ children, ...props }: IProps, ref): JSX.Element => {
    return (
        <GridContainer ref={ref} modeName={'wide'} {...props}>
            {children}
        </GridContainer>
    );
});

WideContainer.displayName = 'ForwardedWideContainer';
export default WideContainer;
